<div id="layout-wrapper">
  @if (!isNotFoundRoute() && !isForceResetPasswordRoute()) {
    <app-topbar
      (settingsButtonClicked)="onSettingsButtonClicked()"
      (mobileMenuButtonClicked)="onToggleMobileMenu()"
    ></app-topbar>
    <app-sidebar [isCondensed]="isCondensed"></app-sidebar>
  }

  @if (!isForceResetPasswordRoute()) {
    <div class="main-content">
      <div class="page-content">
        <router-outlet></router-outlet>
      </div>

      @if (!isNotFoundRoute()) {
        <app-footer></app-footer>
      }
    </div>
  }

  @if (isForceResetPasswordRoute()) {
    <router-outlet></router-outlet>
  }
</div>
